/**
 * Application configuration
 */
export const appConfig = {
  /**
   * Environment
   */
  env: process.env.NODE_ENV || 'staging',

  /**
   * Is production
   */
  isProduction: process.env.NODE_ENV === 'production',

  /**
   * Is staging
   */
  isStaging: (process.env.NODE_ENV as string) === 'staging',

  /**
   * Feature flags
   */
  features: {
    analytics: process.env.ENABLE_ANALYTICS === 'true',
    debugging: process.env.ENABLE_DEBUGGING === 'true',
    maintenance: process.env.MAINTENANCE_MODE === 'true',
  },

  /**
   * Logging configuration
   */
  logging: {
    level: process.env.LOG_LEVEL || 'info',
    enabled: process.env.ENABLE_LOGGING !== 'false',
  },
} as const;
